export const normalizeHtmlId = (input: string) => input.replaceAll(/[^a-zA-Z0-9-_]/g, '_');
